import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalEmbed } from 'volto-gdpr-privacy';
import IFrame from './IFrame';

/**
 * View iframe block
 * @class View
 * @extends Component
 */

const View = ({ data, id }) => {
  return data?.iframe_href ? (
    <div className="block iframe">
      <div className="text-center">
        <ConditionalEmbed url={data?.iframe_href}>
          <IFrame data={data} block={id} />
        </ConditionalEmbed>
      </div>
    </div>
  ) : (
    <></>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
